import { SupabaseClient } from "@supabase/supabase-js";
import { startOfDay, endOfDay } from "date-fns";

export const fetchTransactions = async (
  supabase: SupabaseClient,
  periodStart: Date | null,
  transactionType?: string
) => {
  console.log('Fetching transactions with type:', transactionType);
  
  let query = supabase
    .from('poultry_transactions')
    .select(`
      *,
      stock_items (
        data,
        stock_id
      )
    `)
    .order('created_at', { ascending: false });

  if (periodStart) {
    query = query.gte('created_at', periodStart.toISOString());
    if (periodStart === startOfDay(new Date())) {
      query = query.lte('created_at', endOfDay(new Date()).toISOString());
    }
  }

  if (transactionType && transactionType !== "all") {
    console.log('Filtering by transaction type:', transactionType);
    if (transactionType === "credit_sale") {
      query = query.eq('transaction_type', 'sale')
                  .eq('is_fully_paid', false);
    } else {
      query = query.eq('transaction_type', transactionType);
    }
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error fetching transactions:', error);
    throw error;
  }

  console.log('Raw query result:', data);
  console.log('Number of transactions found:', data?.length || 0);
  if (data && data.length > 0) {
    console.log('First transaction:', data[0]);
    console.log('Transaction types in results:', data.map(t => t.transaction_type));
  }
  return data;
};